import featuredImage1 from "../images/featured-img-1.webp" 
import featuredImage2 from "../images/featured-img-2.webp" 
import featuredImage3 from "../images/featured-img-3.webp" 
import featuredImage4 from "../images/featured-img-4.webp" 
import featuredImage5 from "../images/featured-img-5.webp" 
import featuredImage6 from "../images/featured-img-6.webp" 
import featuredImage7 from "../images/featured-img-7.webp" 
import featuredImage8 from "../images/featured-img-8.webp" 
import featuredImage9 from "../images/featured-img-9.webp" 
import featuredImage10 from "../images/featured-img-10.webp" 
import featuredImage11 from "../images/featured-img-11.webp" 
import featuredImage12 from "../images/featured-img-12.webp" 






const FeaturedItemsImage =[
    {
        "id" : 1,
        "imageLink" : featuredImage1,
        "altText": `Superior Absorbent 100% Cotton Bath Towel - Ideal for Beach & Travel, Quick-Dry, Lightweight | Fast Drying | Multi-Purpose Towels | Striped`,
        "desc": "",
        "sku":"B0CSPBN7L7",
        "type": "",
        "productLink": "https://indusmela.in/products/superior-absorbent-100-cotton-bath-towel-ideal-for-beach-travel-quick-dry-lightweight-fast-drying-multi-purpose-towels-striped-smoke-watermelon?_pos=1&_sid=b2b7c839b&_ss=r&variant=44718985576617",
        "modalId": "featuredImg1",
        "price": "307.00",
        "salePrice": ""
    },
    {
        "id" : 2,
        "imageLink" : featuredImage2,
        "altText": `Turkish Beach Towel |100% Cotton Bath Towel | Ultra-Absorbent, Pool, Travel, Quick-Dry, Lightweight, Oversized, Sandproof| Fast Drying | Multi-Purpose Towels | Striped`,
        "desc": "",
        "sku":"B0CSNDVTS4",
        "type": "",
        "productLink": "https://indusmela.in/products/turkish-beach-towel-100-cotton-bath-towel-ultra-absorbent-pool-travel-quick-dry-lightweight-oversized-sandproof-fast-drying-multi-purpose-towels-striped-blue?_pos=1&_sid=a741005c1&_ss=r&variant=44719096758441",
        "modalId": "featuredImg2",
        "price": "361.00",
        "salePrice": ""
    },
    {
        "id" : 3,
        "imageLink" : featuredImage3,
        "altText": `Handcrafted Cotton Bun Basket Set with 6 Napkins - Multipurpose Napkin Holder, Eco-Friendly Dining Accessory (Floral Green, Confetti Grey)`,
        "desc": "",
        "sku":"B0CSSM6LH7",
        "type": "",
        "productLink": "https://indusmela.in/products/handcrafted-cotton-bun-basket-set-with-6-napkins-multipurpose-napkin-holder-eco-friendly-dining-accessory-floral-green?_pos=1&_sid=830f52a40&_ss=r&variant=45145991119017",
        "modalId": "featuredImg3",
        "price": "659.00",
        "salePrice": ""
    },
    {
        "id" : 4,
        "imageLink" : featuredImage4,
        "altText": `Jacha & Bacha Pure Soft Cotton Dhoti Towels for Babies/Kids Set of 2 Towels-Yellow (Blue) | Light Weight Towels for Kids | Travel Friendly Bath Towels for Children`,
        "desc": "",
        "sku":"B0C23C7DVS",
        "type": "",
        "productLink": "https://indusmela.in/products/jacha-bacha-pure-soft-cotton-dhoti-towels-for-babies-kids-set-of-2-towels-yellow-blue-light-weight-towels-for-kids-travel-friendly-bath-towels-for-children?variant=44719149121705",
        "modalId": "featuredImg4",
        "price": "404.00",
        "salePrice": ""
    },
    {
        "id" : 5,
        "imageLink" : featuredImage5,
        "altText": `Jacha & Bacha Jumbo Gift Set for Newborns - Set of 6 Nappies, 6 Napkins, 2 Towels, 2 Burp Cloth, 1 Liner - Pure Soft Dhoti Cotton (Yellow)`,
        "desc": "",
        "sku":"B0C2MWHPND",
        "type": "",
        "productLink": "https://indusmela.in/products/jacha-bacha-jumbo-gift-set-for-newborns-set-of-6-nappies-6-napkins-2-towels-2-burp-cloth-1-liner-pure-soft-dhoti-cotton-pink?_pos=1&_sid=1dc8c0c4a&_ss=r",
        "modalId": "featuredImg5",
        "price": "415.00",
        "salePrice": ""
    },
    {
        "id" : 6,
        "imageLink" : featuredImage6,
        "altText": `KLEO Kansa Dinner Set–Bronze Thali Set of 6 | 1 Plate, 2 Bowls, 1 Glass, 1 Spoon & 1 Sweet Dish Plate | Bronze Utensils Set for Authentic Indian Dining Colletion, Metal Dinnerware`,
        "desc": "",
        "sku":"B0F6NRNWN7",
        "type": "",
        "productLink": "https://indusmela.in/products/premium-100-cotton-king-size-bedsheet-set-minimalist-design-110-x-105-inches-with-2-pillow-covers-29-x-20-inches-gray?_pos=2&_psq=Premium+100%25+Cotton+King+Size+Bedsheet+Set+-+Minimalist+Design&_ss=e&_v=1.0",
        "modalId": "featuredImg6",
        "price": "1,832.00",
        "salePrice": ""
    }
]



const FeaturedItemsTab =[
    {
        "id" : 9,
        "imageLink" : featuredImage9,
        "altText": `KLEO Sofa Armrest Tray - Handcrafted Acacia Wood Tambour Tray | Flexible & Foldable Dining Table Mat | Water Resistant & Stain Proof | Ideal for Food, Drinks, Snacks, Cup Coaster`,
        "desc": "",
        "sku":"B0DFTQ9C2R",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-sofa-armrest-tray-handcrafted-acacia-wood-tambour-tray-flexible-foldable-dining-table-mat-water-resistant-stain-proof-ideal-for-food-drinks-snacks-cup-coaster?_pos=1&_sid=4f5837e64&_ss=r",
        "modalId": "featuredImg9",
        "price": "1,200.00",
        "salePrice": ""
    },
    {
        "id" : 10,
        "imageLink" : featuredImage10,
        "altText": `KLEO 5" Wide Black Natural Stone Mortar and Pestle Set as Spice, Medicine Grinder Masher - Okhli And Musal`,
        "desc": "",
        "sku":"B0156ODXJ4",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-5-diameter-natural-stone-mortar-and-pestle-set-as-spice-grinder-medicine-masher-okhli-musal-black?_pos=1&_sid=1fc2b5148&_ss=r&variant=44719164719273",
        "modalId": "featuredImg10",
        "price": "941.00",
        "salePrice": ""
    },
    {
        "id" : 11,
        "imageLink" : featuredImage11,
        "altText": `KLEO Marble Stone Shiva Lingam Shiv Ling Idol Murti for Daily Pooja (3.5" Height), Black, Shiva`,
        "desc": "",
        "sku":"B075ZSS3QX",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-natural-black-stone-shivalingam-shivling-shiv-ling-idol-statue-figurine-for-home-decor-and-pooja-3-5-inches?_pos=1&_sid=881ff0a82&_ss=r&variant=44719168684201",
        "modalId": "featuredImg11",
        "price": "339.00",
        "salePrice": ""
    },
    {
        "id" : 12,
        "imageLink" : featuredImage12,
        "altText": `KLEO Marble Chopping Board Cutting Board Cheese Platter - Can be Used as Cheese Salami Cold Meat Platter`,
        "desc": "",
        "sku":"B07415SW5M",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-marble-cutting-board-cheese-platter-multi-purpose-serving-platter-white?_pos=1&_sid=dd19e906d&_ss=r&variant=44719165309097",
        "modalId": "featuredImg12",
        "price": "842.00",
        "salePrice": ""
    }
]

const AllFeaturedItems = FeaturedItemsImage.concat(FeaturedItemsTab)


export { FeaturedItemsImage, FeaturedItemsTab, AllFeaturedItems }